<template>

    <div style="z-index: -1000; display: none;">
      <!-- <div><a href="https://varys.ai">Varys AI - interior design AI for professional, GPT for room and space</a></div>
      <div><a href="https://www.varys.ai">Varys AI - interior design AI for professional, GPT for room and space</a></div>
      <div><a href="https://lite.varys.ai">Varys AI Lite - Take a picture of a room and instantly redesign it in 20+ different themes. No more guesswork, no more costly mistakes.</a></div>
      
      <div><a href="https://ai-architect.net/">Architect AI - AI Architecture Renderer, GPT for Architecture Design Idea Inspiration</a></div>
      <div><a href="https://www.ai-architect.net/">Architect AI - AI Architecture Renderer, GPT for Architecture Design Idea Inspiration</a></div>
      
      <div><a href="https://ai-building.app/">Building AI Render - AI Architecture Renderer, GPT for Architecture Design Idea Inspiration</a></div>
      <div><a href="https://www.ai-building.app/">Building AI Render - AI Architecture Renderer, GPT for Architecture Design Idea Inspiration</a></div>
      
      <div><a href="https://productai.one/">Product AI - AI for Industrial Design Render, GPT for Industrial Design Idea Inspiration</a></div>
      <div><a href="https://www.productai.one/">Product AI - AI for Industrial Design Render, GPT for Industrial Design Idea Inspiration</a></div>
      
      <div><a href="https://interior-ai.design">InRoom Interior AI - Any can re-design your room in seconds by photo, interior design by AI, get design inspiration for designers by GPT</a></div>
      <div><a href="https://www.interior-ai.design">InRoom Interior AI - Any can re-design your room in seconds by photo, interior design by AI, get design inspiration for designers by GPT</a></div>
      
      <div><a href="https://launchai.app/">Launch AI - Launch your AI App</a></div>
      <div><a href="https://www.launchai.app/">Launch AI - Launch your AI App</a></div>
      
      <div><a href="https://ailauncher.app/">AI Launcher - Launch your AI App</a></div>
      <div><a href="https://www.ailauncher.app/">AI Launcher - Launch your AI App</a></div>
      
      <div><a href="https://isjeff.com/">Jeff Portfolio</a></div>
      <div><a href="https://www.isjeff.com/">Jeff Portfolio</a></div> -->

    </div>
  
</template>

<script>


export default {
  name:"linker",
  props:{},
  data(){
    return{}
  },
  created(){},
  methods:{}
}
</script>

<style scoped>




</style>